import { render, staticRenderFns } from "./CalismaRuhsat.vue?vue&type=template&id=55ce8334&scoped=true&"
import script from "./CalismaRuhsat.vue?vue&type=script&lang=js&"
export * from "./CalismaRuhsat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce8334",
  null
  
)

export default component.exports